<!--摆场需求-需求分析表-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form @search="onSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
        <a-select
          allowClear
          slot="version"
          :default-active-first-option="true"
          v-model="queryParams.version"
          option-filter-prop="children"
          option-label-prop="label">
          <a-select-option v-for="(item) in versionSelectList" :key="item" :value="item" :label="item">
            {{ item }}
          </a-select-option>
        </a-select>
        <global-select
          slot="statusList"
          :value.sync="queryParams.promotionName"
          :selectData="statusList"
          selectType="selectFilter"
          :selectItem="{ value: 'lookupValue', label: 'lookupValue' }"
        />
        <a-select slot="fullMeetRemainSentDemandIs" v-model="queryParams.fullMeetRemainSentDemandIs" allowClear>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
        <a-select slot="fullMeetRemainSentOrderIs" v-model="queryParams.fullMeetRemainSentOrderIs" allowClear>
          <a-select-option :value="1">是</a-select-option>
          <a-select-option :value="0">否</a-select-option>
        </a-select>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiScpDemandPlacementBillExport" ref="download" />
        <a-button type="primary" :loading="loading" @click="handleExport">导出</a-button>
        <a-button type="primary" :loading="loading" @click="handleCal">供需运算</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          @successCallBack="successCallBack"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1000 }">
          <template slot="dateFormat2" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD') }}
          </template>
          <template slot="dateFormat" slot-scope="data">
            {{ data.text && $moment(data.text).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
          <!--是否判断-->
          <template slot="isIfObj" slot-scope="data">
            {{ data.text ? '是' : '否' }}
          </template>
          <!--完全满足日期（剩余待发摆场订单）-->
          <template slot="fullMeetRemainSentDemandDate" slot-scope="text">
            <span>{{ text.record.fullMeetRemainSentDemandIs?(text.record.fullMeetRemainSentDemandDate && $moment(text.record.fullMeetRemainSentDemandDate).format('YYYY-MM-DD')):'/' }}</span>
          </template>
          <!--完全满足日期（剩余待发摆场订单）-->
          <template slot="fullMeetRemainSentOrderDate" slot-scope="text">
            <span>{{ text.record.fullMeetRemainSentOrderIs?(text.record.fullMeetRemainSentOrderDate && $moment(text.record.fullMeetRemainSentOrderDate).format('YYYY-MM-DD')):'/' }}</span>
          </template>
           <!--已下摆场订单, 已发摆场订单-->
          <template slot="nullFormat" slot-scope="data">
            <div class="null-class" v-if="data.text===null">-</div>
            <span v-else>{{ data.text }}</span>
          </template>
          <!--状态-->
          <template slot="status" slot-scope="text">
            <span>{{ text.record.fullMeetRemainSentOrderIs?'/':'待新零售进一步确认' }}</span>
          </template>
          <!--计划专员备注-->
          <template #projectDeptPlanRemarkTitle>
            <span>计划专员备注</span>
            <a-icon class="action-icon" @click.stop="onEditRemark('projectDeptPlanRemark')" type="edit" title="编辑"/>
          </template>
          <template slot="projectDeptPlanRemark" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.projectDeptPlanRemark }}</span>
            <a-input v-else type="text" v-model="text.record.projectDeptPlanRemark" :maxLength="100" />
          </template>
          <!--事业部备注-->
          <template #businessUnitRemarkTitle>
            <span>事业部备注</span>
            <a-icon class="action-icon" @click.stop="onEditRemark('businessUnitRemark')" type="edit" title="编辑"/>
          </template>
          <template slot="businessUnitRemark" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.businessUnitRemark }}</span>
            <a-input v-else type="text" v-model="text.record.businessUnitRemark" :maxLength="100" />
          </template>
          <!--计划统筹备注-->
          <template #planCoordinationRemarkTitle>
            <span>计划统筹备注</span>
            <a-icon class="action-icon" @click.stop="onEditRemark('planCoordinationRemark')" type="edit" title="编辑"/>
          </template>
          <template slot="planCoordinationRemark" slot-scope="text">
            <span v-if="!isEdit || currentId !== text.record.id">{{ text.record.planCoordinationRemark }}</span>
            <a-input v-else type="text" v-model="text.record.planCoordinationRemark" :maxLength="100" />
          </template>
          <span slot="operation" slot-scope="text">
            <a v-if="!isEdit || currentId !== text.record.id" @click="handleEdit(text.record)">编辑</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleSave(text.record)">保存</a>
            <a v-if="isEdit && currentId === text.record.id" @click="handleCancel(text.record)" class="ml10">取消</a>
          </span>
        </ls-api-table>
      </div>
      <BatchEditModal ref="BatchEditModalRef" @refreshFun="handleOk" />
    </template>
  </ls-table-layout>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import cloneDeep from 'lodash.clonedeep'
import {
  apiScpDemandPlacementBillList,
  apiScpDemandPlacementBillEdit,
  apiScpDemandPlacementBillCalculate,
  apiScpDemandPlacementBillExport,
  apiVersionList
} from '@/api/scp/pre-order-and-placement/pre-order-and-placement'
import BatchEditModal from '@/views/scp/producingAndMarketing/furniture-placement-demand/demand/components/batch-edit-modal.vue'

export default {
  name: 'Demand',
  components: { DownloadModal, BatchEditModal },
  data() {
    return {
      loading: false,
      versionSelectList: [], // 版本号下拉选择框
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      isEdit: false,
      currentId: "",
      statusList: [], // 状态
      apiScpDemandPlacementBillExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpDemandPlacementBillList, false),
        pageCurrent: true
      },
      // 查询参数
      queryParams: {
        version: undefined,
        promotionName: undefined,
        materialNo: undefined,
        projectTeam: undefined,
        mainModel: undefined,
        planUserName: undefined,
        fullMeetRemainSentDemandIs: undefined,
        fullMeetRemainSentOrderIs: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        { label: '版本号', decorator: ['version'], type: 'version' },
        { label: '促销名称', decorator: ['promotionName'], type: 'statusList' },
        { label: '物料编码', decorator: ['materialNo'], type: 'input' },
        { label: '项目组', decorator: ['projectTeamName'], type: 'input' },
        { label: '主型号', decorator: ['mainModel'], type: 'input' },
        { label: '计划员', decorator: ['planUserName'], type: 'input' },
        { label: '需求是否满足', decorator: ['fullMeetRemainSentDemandIs'], type: 'fullMeetRemainSentDemandIs' },
        { label: '订单是否满足', decorator: ['fullMeetRemainSentOrderIs'], type: 'fullMeetRemainSentOrderIs' }
      ],
      // 表格字段
      columns: [
        { title: '版本号', dataIndex: 'version', align: 'center', width: 160 },
        { title: '物料编码', dataIndex: 'materialNo', align: 'center', width: 150 },
        { title: '物料名称', dataIndex: 'materialName', align: 'center', width: 120, ellipsis: true },
        { title: '规格描述', dataIndex: 'materialSpec', align: 'center', width: 180, ellipsis: true },
        { title: '计划员', dataIndex: 'planUserName', align: 'center', width: 100 },
        { title: '主型号', dataIndex: 'mainModel', align: 'center', width: 130 },
        { title: '项目组', dataIndex: 'projectTeamName', align: 'center', width: 100 },
        { title: '最新摆场总需求', dataIndex: 'latestTotalDemandQuantity', align: 'center', width: 100 },
        { title: '需求数量', dataIndex: 'demandQuantity', align: 'center', width: 100 },
        { title: '需求交期', dataIndex: 'demandDate', align: 'center', scopedSlots: { customRender: 'dateFormat2' }, width: 120 },
        { title: '已下摆场订单', dataIndex: 'distributedOrderQuantity', scopedSlots: { customRender: 'nullFormat' }, align: 'center', width: 120 },
        { title: '已发摆场订单', dataIndex: 'sentOrderQuantity', scopedSlots: { customRender: 'nullFormat' }, align: 'center', width: 120 },
        { title: '剩余待发摆场需求', dataIndex: 'remainToBeSendDemandQuantity', align: 'center', width: 120 },
        { title: '剩余待发摆场订单', dataIndex: 'remainToBeSendOrderQuantity', align: 'center', width: 120 },
        { title: '中心仓库存可用数', dataIndex: 'invUseQty', align: 'center', width: 120 },
        { title: '三仓库存可用数', dataIndex: 'totalInvQty', align: 'center', width: 120 },
        { title: '两库现货', dataIndex: 'twoWarehouseSpotGoodsQuantity', align: 'center', width: 120 },
        { title: 'M月在途PO', dataIndex: 'curMonthOnWayPoQuantity', align: 'center', width: 120 },
        { title: 'M+1月在途PO', dataIndex: 'm1MonthOnWayPoQuantity', align: 'center', width: 120 },
        { title: 'M+2月在途PO', dataIndex: 'm2MonthOnWayPoQuantity', align: 'center', width: 120 },
        { title: 'M+3月在途PO', dataIndex: 'm3MonthOnWayPoQuantity', align: 'center', width: 120 },
        { title: '总在途PO', dataIndex: 'onWayPoQuantity', align: 'center', width: 120 },
        { title: '是否完全满足（剩余待发摆场需求）', dataIndex: 'fullMeetRemainSentDemandIs', scopedSlots: { customRender: 'isIfObj' }, align: 'center', width: 150 },
        { title: '完全满足日期（剩余待发摆场需求）', dataIndex: 'fullMeetRemainSentDemandDate', scopedSlots: { customRender: 'fullMeetRemainSentDemandDate' }, align: 'center', width: 150 },
        { title: '是否完全满足（剩余待发摆场订单）', dataIndex: 'fullMeetRemainSentOrderIs', scopedSlots: { customRender: 'isIfObj' }, align: 'center', width: 150 },
        { title: '完全满足日期（剩余待发摆场订单）', dataIndex: 'fullMeetRemainSentOrderDate', scopedSlots: { customRender: 'fullMeetRemainSentOrderDate' }, align: 'center', width: 150 },
        { title: '促销名称', dataIndex: 'promotionName', align: 'center', width: 110 },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 130 },
        {
          // title: '计划专员备注',
          dataIndex: 'projectDeptPlanRemark',
          align: 'center',
          scopedSlots: { customRender: 'projectDeptPlanRemark', title: "projectDeptPlanRemarkTitle" },
          width: 150
        },
        {
          // title: '事业部备注',
          dataIndex: 'businessUnitRemark',
          align: 'center',
          scopedSlots: { customRender: 'businessUnitRemark', title: 'businessUnitRemarkTitle' },
          width: 150
        },
        {
          // title: '计划统筹备注',
          dataIndex: 'planCoordinationRemark',
          align: 'center',
          scopedSlots: { customRender: 'planCoordinationRemark', title: 'planCoordinationRemarkTitle' },
          width: 150
        },
        { title: '修改人', dataIndex: 'updateName', align: 'center', width: 100 },
        { title: '修改时间', dataIndex: 'updateTime', align: 'center', width: 150, ellipsis: true, scopedSlots: { customRender: 'dateFormat' } },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ]
    }
  },
  created() {
    this.getLookupList('SCP_PLACEMENT_PROMOTION_NAME', 'statusList')
  },
  mounted() {
    this.loading = false;
    this.getVersion();
  },
  methods: {
    // 翻页清除选择
    successCallBack() {
      this.isEdit = false
      this.currentId = '';
      if (this.$refs?.dataTable) this.$refs.dataTable.onClear(); // 清除选择
    },
    // 行选中
    selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    // 批量编辑备注
    onEditRemark(field) {
      if(this.selectedRows.length === 0) {
        return this.$message.warning("请勾选单据进行修改")
      }
      this.$refs.BatchEditModalRef.show(this.selectedRows, field)
    },
    handleEdit(record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 保存
    handleSave(record) {
      this.loading = true;
      apiScpDemandPlacementBillEdit(record).then(res => {
        if (res?.code === 200) {
          this.$message.success('保存成功')
          this.currentId = ''
          this.isEdit = false;
          this.onSearch()
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 取消
    handleCancel() {
      this.isEdit = false;
    },
    // 获取版本
    getVersion() {
      this.versionSelectList = []
      apiVersionList({}).then(res => {
        if (res?.data?.length > 0) {
          this.versionSelectList = res.data
          this.$set(this.queryParams, 'version', res.data[0]) // 默认选第一条，为最新版本
          this.onSearch()
        }
      })
    },
    // 查快码
    getLookupList (type, arr) {
      const lookupQueryParams = { lookupType: type, current: 1, pageSize: 999 }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (response.rows?.length > 0) {
          this[arr] = response.rows
        }
      })
    },
    // 表单搜索
    onSearch(value = {}) {
      this.isEdit = false
      this.currentId = ''
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params)
      this.$refs.dataTable.getData()
    },
    // 新增/修改框事件
    handleOk() {
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery() {
      this.queryParams = {
        version: undefined,
        promotionName: undefined,
        materialNo: undefined,
        projectTeam: undefined,
        mainModel: undefined,
        planUserName: undefined,
        fullMeetRemainSentDemandIs: undefined,
        fullMeetRemainSentOrderIs: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
    },
    // 供需运算
    handleCal() {
      this.loading = true;
      apiScpDemandPlacementBillCalculate({}).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.$message.success('请求成功')
          this.onSearch()
        } else {
          this.$message.error(res?.msg)
        }
      }).finally(e => {
        this.loading = false;
      })
    },
    // 导出
    handleExport() {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
    }
  }
}
</script>

<style scoped lang="less">
.action-icon{
  cursor: pointer;
  font-size: 14px;
  color: #0486fe;
}
.null-class{
  transform: scale(1.2)
}
</style>
